











































































import Vue from 'vue'
import UserMenu from './UserMenu'
import CountdownTimer from '@/components/CountdownTimer'
import KisweStudioLogo from '@/components/Kiswe/KisweStudioLogo'
import ComputerStatsContainer from '@/containers/ComputerStatsContainer'
import CameraMicControlsContainer from '@/containers/CameraMicControlsContainer'
import FirebasePresence from '../../classes/FirebasePresence'
import { Select, Option, Popover } from 'element-ui'
import ConfirmLeaveCast from '@/mixins/ConfirmLeaveCast'
import { isMobile } from 'mobile-device-detect'
import { UserProfile } from '@/types/users'
import { WarningMessage } from '@/classes/Admin/WarningMessage'
import { Cast } from '@/types/casts'
import { Team } from '@/types/teams'
import { KeyDict } from '@/types'
import './TopBar.scss'
import { AbilitySubject, AbilityAction } from '@/abilitiesByRole'
import SubscribeAllTeams from '@/mixins/SubscribeAllTeams'
import SubscribeGlobalWarningMessages from '@/mixins/SubscribeGlobalWarningMessages'
import CastSupportBadge from '@/components/CastSupportBadge/CastSupportBadge.vue'
import SnapShotCounter from '@/components/SnapShotCounter'
import helpers from '@/helpers'
import { Feature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'TopBar',
  mixins: [ ConfirmLeaveCast, SubscribeAllTeams, SubscribeGlobalWarningMessages ],
  props: {
    eventName: {
      type: String,
      required: false,
      default: ''
    },
    supportLevel: {
      type: String,
      required: false
    },
    inEvent: {
      type: Boolean,
      default: false
    },
    eventEndTime: {
      type: Number,
      required: false
    },
    currentUserId: {
      type: String,
      required: true
    },
    currentVersion: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    isMobile (): boolean {
      return isMobile // any mobile device including tablets
    },
    simpleMode (): boolean {
      return this.$store.direct.state.events.simpleMode
    },
    fullscreen (): boolean {
      return this.$store.direct.state.events.fullscreen
    },
    castEnded (): boolean {
      return this.$store.direct.state.events.castEnded
    },
    userEmail (): string {
      return this.$store.direct.state.user.email
    },
    userProfile (): UserProfile | null {
      return this.$store.direct.state.user.profile
    },
    currentCast (): Cast | null {
      return this.$store.direct.state.events.currentCast
    },
    castReady (): boolean {
      return this.$store.direct.state.events.castReady
    },
    allTeams (): Team[] {
      return this.$store.direct.state.team.allTeams
    },
    team (): Team {
      return this.$store.direct.state.team.team
    },
    currentTeam (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    warningMessages () : KeyDict<WarningMessage> {
      return this.$store.direct.state.team.warningMessages
    },
    presence (): FirebasePresence | null {
      return this.$store.direct.state.user.presence
    },
    eventNameShort (): string {
      let name = this.eventName
      if (name.length > 40) {
        name = name.substring(0, 40) + '...'
      }
      return name
    },
    logo (): string {
      return this.team.logo ?? ''
    },
    activeTeams (): Team[] {
      const teams: Team[] = []
      let sortedTeams: Team[] = [this.team]
      if (this.allTeams?.length > 0) {
        sortedTeams = JSON.parse(JSON.stringify(this.allTeams))
      } else if (this.$store.direct.state.user.teams?.length > 0) {
        // Non-ops don't have access to all teams, so use the user profile's teams instead.
        sortedTeams = JSON.parse(JSON.stringify(this.$store.direct.state.user.teams))
      }
      sortedTeams.sort((a, b) => a.name?.toLowerCase() < b.name?.toLowerCase() ? -1 : 1)
      for (const team of sortedTeams) {
        if (team.deleted === false) {
          teams.push(team)
        }
      }
      return teams
    },
    activeTeamName (): string {
      for (const team of this.activeTeams) {
        if (team.id === this.activeTeam) {
          return team.name
        }
      }
      return 'unknown'
    },
    messages (): WarningMessage[] {
      const now = (new Date()).getTime() / 1000
      if (!this.warningMessages) return []
      return Object.values(this.warningMessages).filter(mess => { return mess.timestamp.from < now && mess.timestamp.to > now })
    },
    warningsAvailable (): boolean {
      return this.messages.length > 0 && !this.inEvent
    },
    showUserMenu (): boolean {
      const isAnonymous = !!this.userProfile?.anonymous
      if (isAnonymous) return false
      return true
    }
  },
  watch: {
    inEvent (newVal: boolean): void {
      if (!newVal && this.presence !== null) {
        this.closePresence()
      } else if (this.presence === null) {
        this.setupPresence()
      }
    },
    activeTeam (newVal: string): void {
      this.selectedTeam = newVal
    }
  },
  data: () => ({
    selectedTeam: '',
    sessionId: helpers.makeId()
  }),
  created () {
    this.selectedTeam = this.activeTeam
    if (this.inEvent) this.setupPresence()
  },
  methods: {
    getURL (name, params) {
      if (this.inEvent) return '' //Deactivate link
      return helpers.getURL(this.$router, name, params)
    },
    switchMode () {
      if (this.$can(AbilityAction.Edit, AbilitySubject.Cast)) {
        this.$store.direct.dispatch.events.toggleSimpleMode(!this.simpleMode)
      }
    },
    toggleFullscreen () {
      this.$store.direct.dispatch.events.toggleFullscreen(!this.fullscreen)
    },
    setupPresence () {
      const presence = new FirebasePresence({ sessionId: this.sessionId, uid: this.currentUserId, castId: this.$route.params.id })
      this.$store.direct.dispatch.user.setPresence(presence)
    },
    closePresence () {
      this.$store.direct.dispatch.user.setPresence(null)
    },
    async switchTeam (paramTeam: string) {
      const newTeamVersion = this.activeTeams.find(team => team.id === paramTeam)?.version ?? ''

      await this.$store.direct.dispatch.user.updateProfile({ id: this.currentUserId, currentTeam: paramTeam })
      await this.$store.direct.dispatch.team.setActiveTeam(paramTeam)

      const newUrl = helpers.replaceUrlVersion(window.location.toString(), newTeamVersion)
      if (newUrl !== '') {
        window.location.assign(newUrl)
      } else {
        window.location.reload()
      }
    },
    endCast () {
      this.$store.direct.dispatch.events.castEnded()
    },
    extendEvent () {
      this.$emit('extendEvent')
    }
  },
  components: {
    UserMenu,
    CountdownTimer,
    CameraMicControlsContainer,
    ComputerStatsContainer,
    CastSupportBadge,
    SnapShotCounter,
    KisweStudioLogo,
    'el-select': Select,
    'el-option': Option,
    'el-popover': Popover
  }
})
